export const LayoutActionType = {
  LOAD: 'LOAD',

  RIGHT_PANEL_SHOW: 'RIGHT_PANEL_SHOW',
  RIGHT_PANEL_HIDE: 'RIGHT_PANEL_HIDE',

  BOTTOM_PANEL_SHOW: 'BOTTOM_PANEL_SHOW',
  BOTTOM_PANEL_COLLAPSE: 'BOTTOM_PANEL_COLLAPSE',
  BOTTOM_PANEL_EXPAND: 'BOTTOM_PANEL_EXPAND',

  TRADE_PANEL_SHOW: 'TRADE_PANEL_SHOW',
  TRADE_PANEL_HIDE: 'TRADE_PANEL_HIDE',
};

/**
 * @typedef {Object} LayoutState
 * @property {string} LayoutState.rightPanelItemKey
 * @property {'expand' | 'normal' | 'collapsed'} LayoutState.bottomPanelState
 * @property {boolean} LayoutState.tradePanelShow
 */

/**
 * @type {LayoutState}
 */
export const defaultLayoutState = {
  bottomPanelState: 'normal',
  rightPanelItemKey: 'watchlist',
  tradePanelShow: false,
};

export const defaultRefs = {
  bottomPanelTable: {
    current: {
      refetchTable: () => {},
    },
  },
};